import { FileExcelOutlined, PlusOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { importExcelFile } from '../../../../actions/parent/language/update';
import { ApplicationState } from '../../../../reducers';
import { ThunkAsyncDispatch } from '../../../../../types/global';

type TranslationImportModalProps = {
  handleOnCancel: () => void;
  showImportModal?: boolean;
  segmentId: number;
};

const TranslationImportModal: React.FC<TranslationImportModalProps> = ({
  handleOnCancel,
  showImportModal,
  segmentId,
}) => {
  const { t } = useTranslation();

  const dispatch: ThunkAsyncDispatch = useDispatch();

  const translationTypes = useSelector(
    (state: ApplicationState) => state.resources.data.global.translation_types
  );

  const segmentName = translationTypes.find(type => type.id === segmentId);
  const readFile = (file: any) => {
    handleOnCancel();
    dispatch(importExcelFile(file, segmentId));
  };

  const handleChange = (info: any) => {
    readFile(info.file);
  };

  const renderUploadButton = () => (
    <div data-testid="upload-file">
      <FileExcelOutlined className="background-icon-excel" />
      <div className="flex items-center">
        <PlusOutlined />
        <div className="ml-2">
          {t('common:upload')} {t('common:excel')}{' '}
        </div>
      </div>
    </div>
  );

  return (
    <Modal
      width="50%"
      title={`${t('common:import')} ${segmentName?.name}`}
      open={showImportModal}
      onCancel={() => {
        handleOnCancel();
      }}
      footer={null}
      className="settings-import-modal"
    >
      <Upload
        accept=".xlsx"
        listType="picture-card"
        showUploadList={false}
        customRequest={handleChange}
      >
        {renderUploadButton()}
      </Upload>
    </Modal>
  );
};

export default TranslationImportModal;
